<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :disabled="readonly"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <FieldDateInput
        v-model="dateValue"
        v-bind="$attrs"
        dense
        :name="name"
        @click:clear="clearDate"
        :formatValue="formatValue"
      >
        <template #append>
          <div class="clickable" v-on="on" @click="openMenu()">
            <v-icon>mdi-calendar</v-icon>
          </div>
        </template>
      </FieldDateInput>
    </template>
    <v-card class="d-flex flex-column full-height pa-1" flat>
      <div class="d-flex flex-grom-1">
        <v-date-picker
          v-model="selectDate"
          :allowed-dates="allowedDates"
          :max="max"
          :min="min"
          no-title
          @input="onSelectDate"
        >
        </v-date-picker>
      </div>
      <div class="flex-grow-0 d-flex">
        <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          depressed
          small
          text
          @click="close"
          >Đóng</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          color="error"
          depressed
          small
          text
          @click="onDeleteDate"
          >Xoá</v-btn
        >
        <!-- <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          color="primary"
          depressed
          small
          @click="saveDate"
          >Chọn</v-btn
        > -->
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment'
import FieldDateInput from './field-date-input-format.vue'
export default {
  inheritAttrs: false,
  components: { FieldDateInput },
  props: {
    readonly: Boolean,
    value: {},
    allowedDates: { type: Function, default: () => true },
    min: {},
    max: {},
    formatValue: {
      type: String,
      default: 'DD/MM/YYYY',
    },
  },
  data: () => ({
    menu: false,
    selectDate: '',
    name: '',
  }),
  created() {
    this.name = Math.random()
  },
  watch: {
    value: {
      handler(value) {
        if (!value) return
        try {
          this.selectDate = this.formatDateToPicker(value)
        } catch (error) {
          console.error(error)
          this.selectDate = ''
          this.dateValue = ''
        }
      },
      immediate: true,
    },
  },
  computed: {
    dateValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    typeFormatOuput() {
      return this.formatValue
    },
  },
  filters: {},
  methods: {
    openMenu() {
      this.menu = !this.menu
      if (!this.menu && !this.value) {
        this.selectDate = ''
      }
    },
    formatToValue(value) {
      return value
        ? moment(value, this.typeFormatInput, true).format(this.typeFormatOuput)
        : ''
    },
    formatDateToPicker(value) {
      return value
        ? moment(value, this.typeFormatOuput).format('YYYY-MM-DD')
        : ''
    },
    close() {
      this.menu = false
    },
    clearDate() {
      this.dateValue = ''
    },
    saveDate() {
      let dateStr = `${this.selectDate}`
      this.dateValue = this.formatToValue(dateStr)
    },
    onDeleteDate() {
      this.dateValue = ''
      this.close()
    },
    onSelectDate() {
      this.saveDate()
      this.close()
    },
  },
}
</script>

<style lang="scss">
.v-menu__content {
  .v-card {
    margin: 0 !important;
  }
}
</style>
